let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eX1fm")).then(() => parcelRequire('iKQCz'));